import { info, warn, debug, trace, error } from './services/LogService';
import * as filters from './services/filters';
import { configure, setMetadata, removeMetadata, defaultFilters } from './config/config';

const Logging = {
  configure,
  setMetadata,
  removeMetadata,
  trace,
  debug,
  info,
  warn,
  error,
  filters,
  defaultFilters,
};

export type * from './types/config';
export type * from './types/filter';
export type * from './types/metadata';
export type * from './types/payload';

export default Logging;
